import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/syntenic-gene/',
      name: 'syntenic-gene',
      component: () => import('../views/syntenic-gene.vue'),
    },
    {
      path: '/SearchJBrowse/',
      name: 'SearchJBrowse',
      component: () => import('../views/SearchJBrowse.vue')
    },
    {
      path: '/Annotations/',
      name: 'Annotations',
      component: () => import('../views/Annotations.vue')
    },
    {
      path: '/FlankingRegion/',
      name: 'FlankingRegion',
      component: () => import('../views/FlankingRegion.vue')
    },
    {
      path: '/NonSyntenicOrthologs/',
      name: 'NonSyntenicOrthologs',
      component: () => import('../views/NonSyntenicOrthologs.vue')
    },
    {
      path: '/JBrowse/',
      name: 'JBrowse',
      component: () => import('../views/JBrowse.vue')
    },
    {
      path: '/Marker/',
      name: 'Marker',
      component: () => import('../views/Marker.vue')
    },
    {
      path: '/GenomicSequenceRetrieval/',
      name: 'SequenceInterception',
      component: () => import('../views/SequenceInterception.vue')
    },
    {
      path: '/Userguide/',
      name: 'Userguide',
      component: () => import('../views/Userguide.vue')
    },
    {
      path: '/BLAST/',
      name: 'BLAST',
      component: () => import('../views/BLAST.vue')
    },
    {
      path: '/GeneSequence/',
      name: 'GeneSequence',
      component: () => import('../views/GeneSequence.vue')
    },
    {
      path: '/Download/',
      name: 'Download',
      component: () => import('../views/Download.vue')
    },
    {
      path: '/phylogeneticTree/',
      name: 'phylogeneticTree',
      component: () => import('../views/phylogeneticTree.vue')
    },
    {
      path: '/circos/',
      name: 'circos',
      component: () => import('../views/circos.vue')
    },
    {
      path: '/PrimerDesign/',
      name: 'PrimerDesign',
      component: () => import('../views/PrimerDesign.vue')
    },
    {
      path: '/SearchTandemPairResult/',
      name: 'SearchTandemPairResult',
      component: () => import('../views/SearchTandemPairResult.vue')
    },
    {
      path: '/Transcriptome/',
      name: 'Transcriptome',
      component: () => import('../views/Transcriptome.vue')
    },
    {
      path: '/Polymorph/',
      name: 'Polymorph',
      component: () => import('../views/Polymorph.vue')
    },
    {
      path: '/Polymorph1/',
      name: 'Polymorph1',
      component: () => import('../views/Polymorph1.vue')
    },
    {
      path: '/MSA/',
      name: 'MSA',
      component: () => import('../views/MSA.vue')
    },
    {
      path: '/MSA1/',
      name: 'MSA1',
      component: () => import('../views/MSA1.vue')
    },
    {
      path: '/SpeciesInfo/',
      name: 'SpeciesInfo',
      component: () => import('../views/SpeciesInfo.vue')
    },
    {
      path: '/SyntenicFigure/',
      name: 'SyntenicFigure',
      component: () => import('../views/SyntenicFigure.vue')
    },
    {
      path: '/AnthocyaninGene/',
      name: 'AnthocyaninGene',
      component: () => import('../views/AnthocyaninGene.vue')
    },
    {
      path: '/AuxinGene/',
      name: 'AuxinGene',
      component: () => import('../views/AuxinGene.vue')
    },
    {
      path: '/FlowerGene/',
      name: 'FlowerGene',
      component: () => import('../views/FlowerGene.vue')
    },
    {
      path: '/GlucosinolateGene/',
      name: 'GlucosinolateGene',
      component: () => import('../views/GlucosinolateGene.vue')
    },
    {
      path: '/ResistanceGene/',
      name: 'ResistanceGene',
      component: () => import('../views/ResistanceGene.vue')
    },
    {
      path: '/TranscriptionFactorGene/',
      name: 'TranscriptionFactorGene',
      component: () => import('../views/TranscriptionFactorGene.vue')
    },
    {
      path: '/SearchTranscriptionFactorGene/',
      name: 'SearchTranscriptionFactorGene',
      component: () => import('../views/SearchTranscriptionFactorGene.vue')
    },
    {
      path: '/RegionMicroSynteny/',
      name: 'RegionMicroSynteny',
      component: () => import('../views/RegionMicroSynteny.vue')
    },
    {
      path: '/MutLibGeneSearch/',
      name: 'MutLibGeneSearch',
      component: () => import('../views/MutLibGeneSearch.vue')
    },
    {
      path: '/BrapaLeafeFP/',
      name: 'BrapaLeafeFP',
      component: () => import('../views/BrapaLeafeFP.vue')
    },
    {
      path: '/BrapaLeafCelleFP/',
      name: 'BrapaLeafCelleFP',
      component: () => import('../views/BrapaLeafCelleFP.vue')
    },
    {
      path: '/ProteinStructure/',
      name: 'ProteinStructure',
      component: () => import('../views/ProteinStructure.vue')
    },
    {
      path: '/AthBestHit/',
      name: 'AthBestHit',
      component: () => import('../views/AthBestHit.vue')
    },
    {
      path: '/About/',
      name: 'About',
      component: () => import('../views/About.vue')
    },
    {
      path: '/PHDProject/',
      name: 'PHDProject',
      component: () => import('../views/PHDProject.vue')
    },
]

const router = new VueRouter({
  routes
})

export default router
